import React from 'react';
import { Section, Title, Entry } from '../Section';
import styles from '../Resume.module.scss';

export const SummaryFrontend = ({ ...props }) => {
    if (!process.env.REACT_APP_FRONTEND_RESUME) return null;

    return (
        <Section {...props}>
            <Title id='summary'>Summary</Title>
            <Entry>
                <p className={styles.summaryLead}>
                    Senior Frontend Engineer with 6+ years of experience delivering reliable products across retail, fintech, e-commerce,
                    e-learning, healthcare, and affiliate marketing. This experience spans environments ranging from seed-stage companies
                    with fewer than 10 developers to late-stage scale-ups with 500+ employees and large enterprise retailers. Adapts quickly
                    to unfamiliar domains and codebases, taking ownership from requirements and planning through implementation, testing,
                    release, and production support.
                </p>
                <p className={styles.summaryDetails}>
                    Combines strong React, TypeScript, and JavaScript development with broader engineering skills across UI architecture,
                    state and API integration, automated testing, CI/CD pipelines, cloud tooling, observability, and performance. Skilled at
                    breaking down complex problems, managing work independently, collaborating across product, design, backend, and
                    engineering teams, and guiding maintainable solutions through to completion.
                </p>
            </Entry>
        </Section>
    );
};
